// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DeleteUserConfirmationModal_dialog__u-da7"};